module.exports = __webpack_public_path__ + "img/upload1.9cc18450.svg";